import Vue from 'vue'
import Vuex from 'vuex'
// import patInfoStore from "./modules/patInfoStore";
// import registStore from "./modules/registStore";
// import ybStore from "./modules/ybStore";
// import payStore from "./modules/payStore";

Vue.use(Vuex)

const modulesFiles = require.context('./modules', true, /\.js$/)

const modules = modulesFiles.keys().reduce((modules, modulePath) => {
    // set './app.js' => 'app'
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
    const value = modulesFiles(modulePath)
    modules[moduleName] = value.default
    return modules
}, {})

export default new Vuex.Store({
    // modules: {
    //     patInfoStore,
    //     registStore,
    //     ybStore,
    //     payStore,
    // }
    modules
})